export default function CTA() {
  const scrollToContact = () => {
    // Check if we're on the homepage
    if (window.location.pathname === '/') {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to homepage with hash
      window.location.href = '/#contact';
    }
  };

  const scrollToSection = (sectionId: string) => {
    // Check if we're on the homepage
    if (window.location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to homepage with hash
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5fc4f0e43095545a99ed381ff72fac03.jpg"
          alt="Happy home remodeler contractor"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Scale Your Contracting Business to{' '}
          <span className="text-red-500">7, 8 and 9 Figures</span>?
        </h2>
        <p className="text-xl text-gray-300 mb-10 leading-relaxed">
          Get a free, no-obligation marketing audit and discover exactly how we can help you dominate your local market and generate more high-quality leads.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={scrollToContact}
            className="bg-red-500 text-white px-10 py-5 rounded-lg font-bold text-lg hover:bg-red-600 transition-all hover:shadow-2xl hover:shadow-red-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Claim Your Free Audit Now
          </button>
          <button
            onClick={() => scrollToSection('testimonials')}
            className="bg-white/10 backdrop-blur-sm text-white px-10 py-5 rounded-lg font-bold text-lg hover:bg-white/20 transition-all border-2 border-white/30 hover:border-white/50 whitespace-nowrap cursor-pointer"
          >
            See Success Stories
          </button>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-gray-300">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-red-500 text-2xl"></i>
            <span>No Long-Term Contracts</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-money-dollar-circle-line text-red-500 text-2xl"></i>
            <span>ROI Guaranteed</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-customer-service-2-line text-red-500 text-2xl"></i>
            <span>Dedicated Support</span>
          </div>
        </div>
      </div>
    </section>
  );
}